import { render, staticRenderFns } from "./MemberSignupFormWidget.vue?vue&type=template&id=6077169e&"
import script from "./MemberSignupFormWidget.vue?vue&type=script&lang=ts&"
export * from "./MemberSignupFormWidget.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports